// eslint-disable-next-line import/prefer-default-export
export const getNickname = state => state.profile.data
  && state.profile.data.nickname
    .replace(/(?:^|-)\S/g, a => a.toUpperCase())
    .replace(/-/g, ' ');
